(function (angular) {
    'use strict';

    angular.module('app')
        .controller('userPanelController', userPanelController);

    userPanelController.$inject = [
        '$interval',
        'HeartbeatApi',
        'heartbeat',
        'thisUser',
        'Polls',
        'Events',
        'Surveys',
        'Promotions',
        'Resources',
        'News',
        'modalService',
        '$q',
        'thisSiteSettings',
    ];

    function userPanelController(
        $interval,
        HeartbeatApi,
        heartbeat,
        thisUser,
        Polls,
        Events,
        Surveys,
        Promotions,
        Resources,
        News,
        modalService,
        $q,
        thisSiteSettings,
    ) {
        const vm = this;

        vm.heartbeat = heartbeat;

        vm.createEvent = createEvent;
        vm.createPoll = createPoll;
        vm.createSurvey = createSurvey;
        vm.createResource = createResource;
        vm.createPost = createPost;
        vm.createPromotion = createPromotion;
        vm.appQR = qrShow;
        vm.showSmartphoneIcon = thisSiteSettings.show_qr_code_icon || false;

        /**
         * Shows the create poll modal
         * @return {void}
         */
        function createPoll(): void {
            Polls.managePoll();
        }

        /**
         * Shows the create poll modal
         * @return {void}
         */
        function createSurvey(): void {
            Surveys.manageSurvey();
        }

        /**
         * Shows the create event modal
         * @return {void}
         */
        function createEvent(): void {
            Events.create();
        }

        /**
         * Shows the create promotion modal
         * @return {void}
         */
        function createPromotion(): void {
            Promotions.managePromotion();
        }

        /**
         * Shows the create resource modal
         * @return {void}
         */
        function createResource(): void {
            Resources.manageResource();
        }

        /**
         * Shows the create post modal
         * @return {void}
         */
        function createPost(): void {
            News.manageNews();
        }

        /**
         * Shows the create event modal
         * @return {void}
         */
        function qrShow(): void {
            const deferred = $q.defer();
            //consider in the future changing to use own controller, not needed right now
            modalService.open({
                templateUrl: 'modals/qr-app.html',
                controller: 'manageEventController',
                controllerAs: 'vm',
                windowClass: 'qr-app',
                resolve: {
                    eventId: () => null,
                },
            })
                .result
                .then(deferred.resolve)
                .catch(deferred.reject);
        }


        if (!thisUser) {
            return;
        }
    }

}(angular));
